import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <>
      <Header currentPage="home" />
      <Navigation />
      <div className="image-container">
        <div className="image-box">
          <img src="/images/photo1.jpg" alt="photo1"/>
        </div>
        <div className="image-box">
          <img src="/images/photo2.jpg" alt="photo2"/>
        </div>
      </div>
      <section className="home-date-location">
        <h2 id="home" style={{ fontSize: '3em', fontWeight: '300'}}>
          June 27th, 2026
        </h2>
        <h3 id="home" style={{ fontSize: '1.5em', letterSpacing: '2px', marginBottom: '20px' }}>
          Windham, NY
        </h3>
        <Link to="/rsvp" className="rsvp-btn">RSVP</Link>
      </section>
      <Footer />
    </>
  );
};

export default Home;
